/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Entra_Step2Inputs */



/**
* | output |
* | --- |
* | "Create a custom non-gallery application" |
*
* @param {Scim_Setup_Entra_Step2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_entra_step2 = /** @type {((inputs?: Scim_Setup_Entra_Step2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Entra_Step2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie eine benutzerdefinierte Nicht-Galerie-Anwendung")
	return /** @type {LocalizedString} */ ("Create a custom non-gallery application")
});